import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../services/api";

const BrandingContext = createContext();

export const BrandingProvider = ({ children }) => {
    const [branding, setBranding] = useState({
        applicationName: "Softvative Expense Tracker",
        applicationTitle: "Expense Tracker",
        linkedinUrl: '',
        twitterUrl: '',
        facebookUrl: '',
        instagramUrl: '',
        youtubeUrl: '',
        githubUrl: ''
    });

    useEffect(() => {
        const loadBranding = async () => {
            try {
                const res = await api.get('branding');

                if (res?.data?.data?.applicationTitle) {
                    document.title = res?.data?.data?.applicationTitle;
                }

                setBranding({
                    applicationName: res?.data?.data?.applicationName,
                    applicationTitle: res?.data?.data?.applicationTitle,
                    linkedinUrl: res?.data?.data?.linkedinUrl,
                    twitterUrl: res?.data?.data?.twitterUrl,
                    facebookUrl: res?.data?.data?.facebookUrl,
                    instagramUrl: res?.data?.data?.instagramUrl,
                    youtubeUrl: res?.data?.data?.youtubeUrl,
                    githubUrl: res?.data?.data?.githubUrl,
                });

            } catch (error) {
                console.error("Branding load failed", error);
            }
        };

        loadBranding();
    }, []);

    return (
        <BrandingContext.Provider value={branding}>
            {children}
        </BrandingContext.Provider>
    );
};

export const useBranding = () => useContext(BrandingContext);